import * as Sentry from "@sentry/react";
import { Routes } from "react-router-dom";
import * as VerdiWebClient from "verdi-web-client";

import { getWhoAmI, WhoAmIResponse } from "../session-manager/who-am-i";

interface MeObject extends WhoAmIResponse {
    curUser: string;
    accounts: Account[];
}

interface Account {
    [key: string]: any;
    id: string;
}

/**
 * Sentry - add user info to the Sentry SDK
 */
export async function setSentryUser() {
    const me = (await getWhoAmI()) as MeObject;
    const { adminUsername, admin, id, curUser: currentUserId } = me;

    const currentAccount = VerdiWebClient?.SessionHandler?.currentUserObject ?? undefined;

    // Helps distinguish between app.[test-1/test-0/etc].verdiag.com
    const subdomain = window.location.hostname.split(".")[1];
    // prod url app.verdiag.com has no subdomain, so replace "verdiag" with "prod"
    Sentry.setTag("subdomain", subdomain === "verdiag" ? "prod" : subdomain);

    Sentry.setUser({
        id: currentUserId,
        name: currentAccount?.name,
        admin: {
            isAdmin: admin,
            adminUsername,
            adminId: id,
        },
    });
}

/**
 * Sentry routes component for performance monitoring
 */
export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
